// Domain Models
import { Price, SubscriptionPlanFeature } from ".";

export class SubscriptionPlan {
  constructor(subscriptionPlan = {}) {
    this.id = subscriptionPlan.id;
    this.name = subscriptionPlan.name;
    this.description = subscriptionPlan.description;
    this.recommended = subscriptionPlan.recommended;
    this.active = subscriptionPlan.active;
    this.allowedNumberOfBranches = subscriptionPlan.allowed_number_of_branches;
    this.accessToAnalytics = subscriptionPlan.access_to_analytics;
    this.givesPremiumAccess = subscriptionPlan.gives_premium_access;
    this.trialPeriodDays = subscriptionPlan.trial_period_days || null;
    this.perBookingFee = subscriptionPlan.per_booking_fee || null;
    this.contactOnly = subscriptionPlan.contact_only || false;
    // Contact-only plans (e.g. Enterprise) have no price.
    this.price = subscriptionPlan.price
      ? new Price(subscriptionPlan.price)
      : null;
    this.subscriptionPlanFeatures =
      subscriptionPlan.subscription_plan_features.map(
        feature => new SubscriptionPlanFeature(feature)
      );
  }
}
